import { useEffect } from "react";

import { AddReceivingInvoiceViewModel } from "../../../viewmodels/receiving/invoices/AddReceivingInvoiceViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import AddReceivingInvoiceForm from "../../../components/forms/receiving/invoices/AddReceivingInvoiceForm";
import EmptyModal from "../../../components/modals/EmptyModal";

function AddReceivingInvoice(props) {
  const { addSnackbar, logout } = props;
  const {
    barcodeDetails,
    createReceivingInvoice,
    getAllAssemblyItems,
    getAssemblyItemByPlu,
    invoice,
    invoiceItems,
    setInvoiceItems,
    onGenerateBarcodePdf,
    productTypeOptions,
    loading,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    openReceivingItemDetails,
    deleteReceivingItem,
    deleteMultipleReceivingItems,
    getEmployeesForDropdown,
    employeeOptions,
    suppliers,
    getSuppliersForDropdown,
    getInvoiceProducts,
    getInvoiceLots,
    getInvoiceLotItems,
    lotsLoading,
    itemsLoading,
  } = AddReceivingInvoiceViewModel(logout, addSnackbar);

  useEffect(() => {
    getEmployeesForDropdown();
    getSuppliersForDropdown();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <AddReceivingInvoiceForm
          addItemToReceivingInvoice={null}
          barcodeDetails={barcodeDetails}
          createReceivingInvoice={createReceivingInvoice}
          invoice={invoice}
          onGenerateBarcodePdf={onGenerateBarcodePdf}
          productTypeOptions={productTypeOptions}
          getAllAssemblyItems={getAllAssemblyItems}
          getAssemblyItemByPlu={getAssemblyItemByPlu}
          setSlideOver={setSlideOver}
          isEdit={false}
          invoiceItems={invoiceItems}
          setInvoiceItems={setInvoiceItems}
          showErrorModal={showErrorModal}
          openReceivingItemDetails={openReceivingItemDetails}
          deleteReceivingItem={deleteReceivingItem}
          deleteMultipleReceivingItems={deleteMultipleReceivingItems}
          setEmptyModelOpen={setEmptyModelOpen}
          employeeOptions={employeeOptions}
          suppliers={suppliers}
          getInvoiceProducts={getInvoiceProducts}
          getInvoiceLots={getInvoiceLots}
          getInvoiceLotItems={getInvoiceLotItems}
          lotsLoading={lotsLoading}
          itemsLoading={itemsLoading}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-3xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddReceivingInvoice),
);
